import _cloneDeep from 'lodash/cloneDeep';

import { tierPayloadToForm } from 'containers/Campaign/Referral/TierLadder/payload';

export const campaignNormalizeData = campaign => {
  const clonedCampaign = _cloneDeep(campaign);

  if (clonedCampaign.campaign_type === 'stamp') {
    if (clonedCampaign.outcomes && clonedCampaign.outcomes.length > 0) {
      clonedCampaign.initialSlottedRewards = clonedCampaign.outcomes; // prepare for initial reward, it will get preprocessed inside campaign mechanic page
    }
  }

  if (clonedCampaign.campaign_type === 'game') {
    if (clonedCampaign.game_type === 'survey' || clonedCampaign.game_type === 'quiz') {
      clonedCampaign.campaign_type = clonedCampaign.game_type;
    }
  }

  if (clonedCampaign.campaign_type === 'invite') {
    clonedCampaign.properties = clonedCampaign.properties ?? {};
    if (clonedCampaign.tier_based_invite === true) {
      // Hydrate properties.reward_mode + properties.tier_ladder.tiers[] from
      // the top-level wire shape (tiers[] + transaction_rule + blueprint-shaped
      // tier outcomes) so the redux-form Referral UI renders correctly.
      return tierPayloadToForm(clonedCampaign);
    }
    if (!clonedCampaign.properties.reward_mode) {
      clonedCampaign.properties.reward_mode = 'fixed';
    }
  }

  if (clonedCampaign.campaign_type === 'streak') {
    clonedCampaign.temp = {
      interval_id: clonedCampaign.streak_intervals[0]?.id,
      streak_period: clonedCampaign.streak_intervals[0]?.streak_period,
      trigger_type: clonedCampaign.streak_campaign_mechanics?.streak_type,
      streak_unit: clonedCampaign.streak_intervals[0]?.streak_unit,
      event_count: clonedCampaign.streak_intervals[0]?.event_count,
      streak_mode: clonedCampaign.streak_campaign_mechanics?.streak_mode,
      target_spend: clonedCampaign.streak_intervals[0]?.target_spend
    };
    clonedCampaign.outcomes = clonedCampaign.streak_intervals[0]?.outcomes;
    clonedCampaign.milestones = clonedCampaign.streak_intervals;
  }

  return clonedCampaign;
};
